import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist/utilities'
import {
  DepartmentsTableSearchProps,
  DepartmentsTableSortProps
} from './departments-table-store.types'

export const initialDepartmentsTablePaginationProps: PaginationProps<DepartmentsTableSortProps> = {
  page: 0,
  size: window.innerWidth >= 1920 ? 10 : 6,
  sortDirection: SortDirection.ASC,
  sortProp: DepartmentsTableSortProps.DEPARTMEMENTS,
  totalElements: 0,
  totalPages: 0
}

export const initialDepartmentsTableSearchProps: DepartmentsTableSearchProps = {
  name: ''
}

export const departmentsTableNeedTimeoutSearchProps: Array<keyof DepartmentsTableSearchProps> = [
  'name'
]
